<template>
  <v-container fluid align-content="center" align="center" justify="center">
    <v-row>
      <event :event="event" :account_id="event.account_id" />
    </v-row>
  </v-container>
</template>

<script>
//http://192.168.0.89:8080/eid?q=60804150542246a39753ea8f
export default {
  components: {
    Event: () => import('@/views/Components/Event')
  },
  data() {
    return {
      event: {}
    }
  },
  async created() {
    const eid = this.$route.query.q
    if(eid && eid != ""){
      const event_id = await this.getEventIdFromShort(eid)
      this.getEvent(event_id)
    }
  },
  methods:{
    async getEventIdFromShort(eid) {
      const event_id = await this.$http.get(`short/${eid}`)
      return event_id.data
    },
    getEvent(eid) {
      this.$http.post('get_event_for_operator',{event_id:eid})
        .then(resp => this.event = resp.data)
        .catch(err => console.log(err))      
    }
  }
}
</script>

<style>

</style>